export enum NotificationSection {
  STAFF_MANAGEMENT = 'staff-management',
  ABSENCE_MANAGEMENT = 'absence-management',
  SHIFT_MANAGEMENT = 'shift-management',
  INCIDENT_MANAGEMENT = 'incident-management',
  INTERNAL_CHAT = 'internal-chat',
  HIRING = 'hiring',
  TRAINING_MANAGEMENT = 'training-management',
}

export const NOTIFICATION_SECTION_VALUES = Object.values(NotificationSection);
